<template><div class="main">
  <sticky-bar @back="$router.push(`/s/f/${fid}`)">
    {{ fleet && fleet.name || 'Loading...' }}
    <small>Schedule</small>
  </sticky-bar>
  <div v-if="!fleet || !timezones" class="padded">
    <Loading v-if="timezones || timezonesLoading" />
    <button v-else class="error" @click="$store.dispatch('fetchTimezones')">
      An error occurred. Click here to try again.
    </button>
  </div>
  <div v-else class="schedule padded"><div>
    <schedule-card :unit_id="u.id" :unit_name="u.name" v-for="u in units" :key="u.name" />
  </div></div>
</div></template>
<script>
import Loading from '../../Loading'
import ScheduleCard from './ScheduleCard'
import StickyBar from '../../StickyBar'
export default {
  name: 'fleet-schedule',
  components: { Loading, ScheduleCard, StickyBar },
  props: { fid: { default: null } },
  created() { this.$store.dispatch('fetchTimezones') },
  data() {
    return {
    }
  },
  computed: {
    fleet() { return (this.fid !== null) && this.$store.getters.fleets[this.fid] || null },
    units() { return this.fleet.units.map(uid => this.$store.state.units[uid]).filter(u => !!u) },
    timezones() { return this.$store.state.timezones },
    timezonesLoading() { return (this.$store.state.timezonesRef !== null) },
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
.schedule {
  > div {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: flex-start;
  }
}
</style>
